import React from 'react';

// Router Dom
import { useHistory } from 'react-router-dom';

// clsx
import clsx from 'clsx';

// Material
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';

// Icons
import ArrowBack from '@material-ui/icons/ArrowBack';
import ArrowForward from '@material-ui/icons/ArrowForward';

// styles
import useStyles from './BackAndForwardControl.styles';

interface BackAndForwardControlInterface {
  handleButton?: false | (() => void);
  handleGoForward?: false | (() => void);
  disabledForward?: boolean;
  disabledBack?: boolean;
  customMargin?: boolean;
}

const BackAndForwardControl: React.FC<BackAndForwardControlInterface> = ({
  handleButton,
  handleGoForward,
  disabledForward,
  disabledBack,
  customMargin,
}) => {
  const classes = useStyles();
  const history = useHistory();

  return (
    <Box
      className={clsx(classes.butonNavegation, {
        [classes.customMargin]: customMargin,
      })}>
      <IconButton
        onClick={handleButton || (() => history.goBack())}
        disabled={disabledBack}>
        <ArrowBack />
      </IconButton>
      <IconButton
        onClick={handleGoForward || (() => history.goForward())}
        disabled={disabledForward}>
        <ArrowForward />
      </IconButton>
    </Box>
  );
};

export { BackAndForwardControl };
export default BackAndForwardControl;
